import CheckIcon from '@mui/icons-material/Check';
import {
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/** @param {import("prop-types").InferProps<typeof PricingCardPropTypes>} props */
export default function PricingCard({ title, description, price, url, perks, promote = false }) {
  const { t } = useTranslation();

  return (
    <Card
      variant="outlined"
      sx={[
        {
          padding: 2,
          border: '4px solid white',
          borderRadius: '16px',
          width: '100%',
          height: '100%',
        },
        promote && { borderColor: 'rgb(59, 130, 246)' },
      ]}
    >
      <CardContent>
        <Typography gutterBottom variant="h4" className="font-bebas">
          {title}
        </Typography>
        {description.length > 0 ? (
          <Typography variant="subtitle1" color="error" className="font-bebas">
            {t('ticket.prefix')} {description}
          </Typography>
        ) : (
          <div style={{ height: '28px' }} />
        )}
        <Typography variant="h4" component="div" sx={{ margin: '16px 0' }} className="font-bebas">
          {price}
          {price !== 'TBD' && (
            <Typography
              variant="subtitle2"
              component="span"
              sx={{ marginLeft: 1 }}
              className="font-bebas"
            >
              {t('ticket.suffix')}
            </Typography>
          )}
        </Typography>
        <Button
          fullWidth
          disabled={!url}
          variant="contained"
          color="secondary"
          sx={{ marginBottom: 2 }}
          component="a"
          href={url}
          className="font-bebas"
        >
          {t('ticket.buy')}
        </Button>
        <List>
          {perks.filter(Boolean).map(perk => (
            <ListItem key={perk} disablePadding>
              <ListItemIcon>
                <CheckIcon color="success" />
              </ListItemIcon>
              <ListItemText primary={perk} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}

const PricingCardPropTypes = {
  description: PropTypes.string.isRequired,
  perks: PropTypes.arrayOf(PropTypes.string).isRequired,
  price: PropTypes.string.isRequired,
  promote: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
PricingCard.propTypes = PricingCardPropTypes;
